<!-- PROVIDER_REQUESTS_REFUND_RELEASE -->

<template>
  <div :class="['ms-form', 'ms-form--narrow', { purpose: this.data?.body?.purpose }]">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomSelect :options="warehouseOptions" label="Склад" :required="true" optionValueKey="warehouse_id"
          optionLabelKey="warehouse_name" :fullWidth="true" :value="this.formData.warehouse_id"
          @change="(value) => onChange('warehouse_id', value)" />
      </div>
      <CustomModalFooter :btn-loading="this.btnLoading" />
    </q-form>
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomSelect from "@/components/form/CustomSelect";
import { getWarehousesForRelease } from "@/views/ProviderRequests/services";

export default {
  name: "prov-req-refund-release",
  components: { CustomModalFooter, CustomSelect },
  props: ['data'],
  data() {
    return {
      loading: false,
      btnLoading: false,
      formData: {
        provider_request_id: this.data?.providerRequestId || '',
        warehouse_id: '',
        provider_request_invoice_item_id_arr: this.data?.body?.data
          ? this.data.body.data.map(item => item.provider_request_item_id)
          : '',
      },
      warehouseOptions: [],
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value;
    },
    async onSubmit() {
      this.btnLoading = true
      await this.data?.onSubmit(this.formData)
      this.btnLoading = false
    },
    async fetchWarehouses() {
      this.warehouseOptions = await getWarehousesForRelease();
    },
  },
  mounted() {
    this.fetchWarehouses();
  }
}
</script>